<template>
  <div class="Index">
    <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">认识手机</div>
      </div>
      <div class="haerd_right"></div>
    </div>

    <div class="module_box">

      <div class="health Icon" @click.stop.prevent="goIcon">
        <div class="module_left">认识手机常用图标</div>
        <div class="module_right_icon1 Icon1">
          <div class="module_right_icon2 Icon2">
            <div class="module_right_icon3 Icon3"></div>
          </div>
        </div>
      </div>

      <div class="health module"  @click.stop.prevent="goModule">
        <div class="module_left">认识手机常用组件</div>
        <div class="module_right_icon1 Component1">
          <div class="module_right_icon2 Component2">
            <div class="module_right_icon3 Component3"></div>
          </div>
        </div>
      </div>

      <div class="health"  @click.stop.prevent="goPage">
        <div class="module_left">认识手机常用界面</div>
        <div class="module_right_icon1 Interface1">
          <div class="module_right_icon2 Interface2">
            <div class="module_right_icon3 Interface3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goSoftware">
        <div class="module_left">认识手机常用软件</div>
        <div class="module_right_icon1 Software1">
          <div class="module_right_icon2 Software2">
            <div class="module_right_icon3 Software3"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="prompt">温馨提示：模拟体验，非真实操作。</div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data () {
    return {}
  },
  created () {},

  mounted () {},
  beforeDestroy () {},

  methods: {
    async goBack () {
      this.$router.replace({
        path: '/classification'
      })
    },
    async goIcon () {
      this.$router.push({
        path: '/recognize/iconIndex'
      })
    },
    async goModule () {
      debugger
      this.$router.push({
        path: '/recognize/moduleIndex'
      })
    },
    async goPage () {
      debugger
      this.$router.push({
        path: '/recognize/pageIndex'
      })
    },
    async goSoftware () {
      debugger
      this.$router.push({
        path: '/recognize/softwareIndex'
      })
    }
  }
}
</script>

<style scoped lang="less">
.newTop {
  top: 280px !important;
}
.newpadding {
  padding: 36px 40px 0 !important;
}
.newmargin {
  margin-top: 30px !important;
}
.Index {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: linear-gradient(180.00deg, rgb(95, 141, 255) 6.107%,rgb(144, 181, 252) 39.695%,rgb(217, 240, 255) 99.237%);
  background-size: 100% 100%;
  border-radius: 0px;
  .window_bg {
    pointer-events: none; /* 使点击穿透该元素 */
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url(@/assets/use/useIndex/window_bg.png) no-repeat center;
    background-size: 100% 100%;
  }
}
.haerd {
  padding: 40px 30px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url(@/assets/use/useIndex/backBtn.png) no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 44px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      margin-top: 40px;
      // margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 70px;
      width: 45vw;
      color: #ffffff;
      // line-height: 1.2;
    }
  }
  .haerd_right {
    position: absolute;
    right: 40px;
    top: 40px;
    z-index: 0;
    width: 361px;
    height: 270px;
    background: url(@/assets/recognize/recognizeIndex/recognizeIndex_subscript.png)
      no-repeat center;
    background-size: 100% 100%;
    //   opacity: 0.7;
  }
}

.module_box {
  // width: 100%;
  // margin: 0 40px 0;
  position: absolute;
  top: 360px;
  max-height: 910px;
  overflow-y: auto;
  padding-right: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 0 30px;
  .health {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    // flex-direction: column;
    align-items: center;
    width: 325px;
    padding: 27px 0;
    // height: 150px;
    background: #ffffff;
    border-radius: 15px;
    margin-bottom: 30px;
    margin-right: 30px;
    .module_left {
      display: flex;
      // justify-content: center;
      margin-left: 20px;
      align-items: center;
      width: 150px;
      // height: 71px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: 500;
      font-size: 33px;
      letter-spacing: 2px;
      color: #333333;
      // margin-left: 20px;
      z-index: 99;
    }

    .module_right_icon1 {
      width: 250px;
      height: 253px;
      position: absolute;
      right: -25%;
      top: -50%;
      .module_right_icon2 {
        width: 130px;
        height: 117px;
        position: absolute;
        left: 22%;
        bottom: 4.5%;
        .module_right_icon3 {
          width: 70px;
          height: 70px;
          position: absolute;
          left: 13.5%;
          top: 23.5%;
        }
      }
    }

    .Icon1 {
      background: url("@/assets/colorBg/orange1.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Icon2 {
      background: url("@/assets/colorBg/orange2.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Icon3 {
      background: url(@/assets/recognize/recognizeIndex/icon_icon3.png)
        no-repeat center;
      background-size: 100% 100%;
    }
    .Component1 {
      background: url("@/assets/colorBg/blue1.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Component2 {
      background: url("@/assets/colorBg/blue2.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Component3 {
      background: url(@/assets/recognize/recognizeIndex/component_icon3.png)
        no-repeat center;
      background-size: 100% 100%;
    }
    .Interface1 {
      background: url("@/assets/colorBg/green1.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Interface2 {
      background: url("@/assets/colorBg/green2.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Interface3 {
      background: url(@/assets/recognize/recognizeIndex/interface_icon3.png)
        no-repeat center;
      background-size: 100% 100%;
    }
    .Software1 {
      background: url("@/assets/colorBg/purple1.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Software2 {
      background: url("@/assets/colorBg/purple2.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Software3 {
      background: url(@/assets/recognize/recognizeIndex/software_icon3.png)
        no-repeat center;
      background-size: 100% 100%;
    }
  }
  .health:nth-child(2n) {
    margin-right: 0;
  }
}

.prompt {
  width: 100%;
  position: absolute;
  bottom: 2vh;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 30px;
  color: #666666;
  text-align: center;
}
// }
</style>
